module.exports = __webpack_public_path__ + "img/status_3.06cae20c.png";